export const MAX_UPLOAD_MB = 20; // 3MB
export const MAX_UPLOAD_SIZE = 1024 * 1024 * MAX_UPLOAD_MB; // x MB
export const ACCEPTED_FILE_TYPES = [
  "image/png",
  "image/jpeg",
  "application/pdf",
];
